exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* override CRISP styles */\n.container {\n    max-width: 100% !important;\n}\n", ""]);

